<template>
  <div class="content main-container">
    <div class="info" ref="infoBox">
      说明：
      <br />1、商户可在此页面查看自己最新的提现申请状态和历史提现记录。 <br />2、商户申请提现后，平台将在收到发票后的5个工作日内（节假日顺延）完成付款。
      <br />3、因银行转账时间的差异，提现申请将在财务打款后的1-3日内到账。若提现申请状态显示“转账完成”，说明已向银行安排付款，银行正在处理，请耐心等待。
    </div>
    <Tabs v-model="tabId" :animated="false" @on-click="searchAjax()">
      <TabPane label="待上传发票" name="1"></TabPane>
      <TabPane label="已发起提现" name="2"></TabPane>
    </Tabs>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">创建时间</span>
        <DatePicker
          :transfer="true"
          type="daterange"
          split-panels
          separator=" 至 "
          format="yyyy-MM-dd"
          :value="searchParams.date"
          @on-change="$set(searchParams, 'date', $event)"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item" v-if="tabId == 2">
        <span class="label">提现状态</span>
        <Select v-model="searchParams.status" placeholder="请选择" clearable>
          <Option value="">全部</Option>
          <Option value="0,3">申请中</Option>
          <Option value="1">提现成功</Option>
          <Option value="2">已驳回</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <div class="detail">
            <div @click="$refs.withdrawalMergeList.open('edit', row)">详情</div>
            <div @click="download(row)">结算函及明细下载</div>
            <div @click="$refs.confirmWidthdraw.open(row)">上传发票</div>
            <div @click="delWithdraw(row)">撤销</div>
          </div>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
    <!-- 确定提现，上传资料 -->
    <confirmWidthdraw ref="confirmWidthdraw" @reload="getList()" />
    <!-- 提现合并数据列表 -->
    <withdrawalMergeList ref="withdrawalMergeList" @reload="getList()" />
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal" />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import filter from '@/api/filter';
import confirmWidthdraw from './components/confirmWidthdraw';
import withdrawalMergeList from './components/withdrawalMergeList.vue';
import confirmModal from '@/components/commons/confirmModal';
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  components: {
    confirmWidthdraw,
    confirmModal,
    withdrawalMergeList
  },
  props: {},
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tabId: '1',
      searchParams: {},
      searchForm: [],
      tableDate: [],
      columns: []
    };
  },
  watch: {},
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.initListParams('/buz/merchantWithdrawLog/read/listMy');
  },
  activated() {
    if (sessionStorage.query) {
      this.tabId = JSON.parse(sessionStorage.query).tabId || '1';
      this.status = JSON.parse(sessionStorage.query).status || '';
      sessionStorage.removeItem('query');
    }
    this.getList();
  },
  methods: {
    // 转化参数
    setListParams(params) {
      this.getColumns();
      if (this.tabId == '1') {
        params.statusList = [5];
        delete params.status;
      } else if (this.tabId == '2') {
        params.statusList = [0, 1, 2, 3];
        if(params.status) {
          delete params.statusList;
          if(params.status.includes(',')){
            params.statusList = params.status.split(',');
            delete params.status;
          }
        }
      }
      if(params.date && params.date[0]) {
        params.startTime = params.date[0];
        params.endTime = params.date[1];
      }
      delete params.date;
    },
    getColumns() {
      let columns = [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '创建时间',
          key: 'requestTime',
          minWidth: 160,
          align: 'center',
          tooltip: true,
          render(h, params) {
            const value = filter.filterTime(params.row.requestTime, 'YYYY-MM-DD');
            return <span>{value}</span>;
          }
        },
        {
          title: '申请金额（元）',
          key: 'requestAmount',
          minWidth: 160,
          align: 'center',
          tooltip: true
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 120,
          align: 'center',
          tooltip: true,
          render(h, params) {
            const map = {
              '0': '申请中',
              '1': '提现成功',
              '2': '已驳回',
              '3': '申请中',
              '5': '待上传'
            };
            return <span>{map[params.row.status]}</span>;
          }
        }
      ];
      if (this.tabId == 1) {
        columns.push({
          title: '操作',
          slot: 'action',
          width: 280,
          align: 'center'
        });
      } else if (this.tabId == 2) {
        columns.push({
          title: '备注',
          key: 'remark',
          minWidth: 160,
          align: 'center',
          tooltip: true
        });
      }
      this.columns = columns;
    },
    delWithdraw(row) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '确定撤销提现？'
        })
        .then(() => {
          this.$http({
            type: 'delete',
            url: '/buz/settlementTotal/delWaitUploadWithdraw',
            query: {
              withdrawLogId: row.id
            }
          }).then(res => {
            this.getList();
            this.$notice.success('操作成功');
          });
        });
    },
    // 下载资料
    download(row) {
      this.$units.downloadFile('/buz/settlementDetail/settleConfirmDownload', { withdrawLogId: row.id }, 'get');
    },
  }
};
</script>
<style lang="scss" scoped>
.info {
  margin-bottom: 15px;
  color: #6e574a;
  line-height: 1.6;
  border-radius: 4px;
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  font-size: 13px;
}
</style>
